import { orderService } from '@/services/order'

const state = {
  orders: [],
  aco: {},
}



const actions = {
  getOrders({ commit, dispatch }, payload) {
    orderService.getOrders()
      .then(
        orders => {
          commit('setOrders', orders)
        },
        error => {
          console.error(error)
          dispatch('alert/error', error.toString(), { root: true })
        }
      )
  },
  createOrder({ commit }, orderData) {
    orderService.createOrder(orderData)
      .then(order => {
        // console.log(order)
        commit('pushOrder', order)
      })
      .catch(err => {
        console.error(err)
      })
  }
}
const mutations = {
  setOrders(state, orders) {
    state.orders = orders
  },
  setAco(state, orders) {
    console.log(orders), 155
    state.aco = orders
  },
  pushOrder(state, order) {
    state.orders.push(order)
  },
  spliceOrder(state, orderId) {
    let rmIndex = state.orders.findIndex(orderId)
    if (rmIndex == -1) return console.error(`spliceOrder no order with id ${orderId}`)
    rmIndex.splice(rmIndex, 1)
  }
}

const getters = {
  getOrderById: (state) => (id) => {
    return state.orders.find(order => order.orderId == id)
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}